import React, { useEffect, useState } from 'react';
import axios from '../axiosInstance';

const Home = () => {
  const [topBanners, setTopBanners] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const fetchTopBanners = async () => {
    try {
      const res = await axios.get('/api/banners?page=1');
      setTopBanners(res.data.slice(0, 8));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchTopBanners();
  }, []);

  // === NOUVEAU AADS ADAPTATIF (mobile + desktop) ===
useEffect(() => {
  const div = document.createElement("div");
  div.innerHTML = `
    <!-- BEGIN AADS AD UNIT 2425494 -->   
    <!-- END AADS AD UNIT 2425494 -->
  `;
  document.body.appendChild(div);
  return () => document.body.removeChild(div);
}, []);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 font-sans overflow-hidden">
      {/* NAVBAR */}
      <header className="bg-gray-900/95 backdrop-blur-xl border-b border-gray-800 sticky top-0 z-50">
  <div className="max-w-7xl 2xl:max-w-none mx-auto px-4 sm:px-6 2xl:px-10 py-4 sm:py-5">
    <div className="flex items-center justify-between">
      
      {/* Logo + Hamburger (visible seulement mobile) */}
      <div className="flex items-center gap-4">
        <img 
          src="/bannerRank.png" 
          alt="RankMyBanner" 
          className="h-9 sm:h-10 w-auto drop-shadow-[0_0_15px_rgb(16,185,129)]" 
        />
        
        {/* Hamburger - visible < md */}
        <button 
          type="button" 
          className="md:hidden text-emerald-400 focus:outline-none"
          aria-label="Toggle menu"
           onClick={() => setIsOpen(!isOpen)}
        >
           {/* SVG hamburger ou croix selon isOpen */}
            {isOpen ? (
              <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
        </button>
      </div>

      {/* Navigation */}
      <nav
            className={`
              ${isOpen ? 'block' : 'hidden'}              // affiche/cache sur mobile quand on clique
              md:flex md:items-center                     // sur desktop → toujours visible + flex horizontal
              absolute md:static top-full left-0 right-0  // position absolute sur mobile pour dropdown
              bg-gray-900/95 md:bg-transparent            // fond sombre sur mobile, transparent sur desktop
              border-b border-gray-800 md:border-none     // bordure basse sur mobile uniquement
              p-6 md:p-0                                  // padding plus important sur mobile
              flex flex-col md:flex-row                   // colonne sur mobile, ligne sur desktop
              gap-6 md:gap-x-8 md:gap-y-0                 // espacement adapté
              text-sm font-medium                         // style texte
              z-40                                        // au-dessus du reste si besoin
            `}
          >
        <a href="/" className="text-emerald-400 transition hover:text-emerald-300">Home</a>
        <a href="/leaderboard" className="hover:text-emerald-400 font-semibold transition">Leaderboard</a>
        <a href="/submit" className="hover:text-emerald-400 transition">Submit Your Banner</a>
        <a href="/claim" className="hover:text-emerald-400 transition">Claim Points</a>
        <a href="/how-to-increase" className="hover:text-emerald-400 transition">How to Increase</a>
      </nav>

      {/* Pub – cachée sur < 2xl */}
      <div className="hidden 2xl:block flex-shrink-0">
        <iframe 
          src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
          width="728" 
          height="90" 
          scrolling="no" 
          border="0" 
          frameBorder="0"
        />
      </div>
    </div>
  </div>
</header>

       {/* TOP BANNERS */}
       <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex justify-between items-end mb-12">
            <h2 className="text-5xl font-black tracking-tight">HOT BANNERS RIGHT NOW</h2>
            <a href="/leaderboard" className="text-emerald-400 hover:text-emerald-300 flex items-center gap-3 text-lg font-medium">
              FULL LEADERBOARD <span className="text-2xl">→</span>
            </a>
            
          </div>

              
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {topBanners.map((banner, index) => (
              <div
                key={banner.id}
                className="group bg-gray-900 border border-gray-800 rounded-3xl overflow-hidden hover:border-emerald-500 hover:shadow-2xl hover:shadow-emerald-500/20 transition-all duration-300 flex flex-col"
              >
                <div className="relative">
                  <div className="absolute top-5 left-5 z-10 px-5 py-1 bg-black/80 text-emerald-400 text-xs font-bold rounded-full border border-emerald-400/50">
                    #{index + 1}
                  </div>
                  <div className="h-48 bg-gray-950 flex items-center justify-center overflow-hidden">
                    <img
                      src={banner.image_url}
                      alt={`Banner ${index + 1}`}
                      className="max-h-40 w-auto object-contain group-hover:scale-110 transition duration-500"
                    />
                  </div>
                </div>

                <div className="p-6 flex-1 flex flex-col">
                  <div className="text-emerald-400 font-bold text-xl mb-1">{banner.points} PTS</div>
                  <a
                    href={`https://rankmybanner.click/visit/${banner.slug}`}
                    className="text-blue-400 hover:underline text-xs break-all mb-4 block"
                  >
                    rankmybanner.click/visit/{banner.slug}
                  </a>
                  <p className="text-sm text-gray-400 line-clamp-3 flex-1">{banner.description}</p>

                  <a
                    href={banner.target_url}
                    target="_blank"
                    className="mt-6 block text-center bg-emerald-500 hover:bg-emerald-600 py-3.5 rounded-2xl text-sm font-bold transition"
                  >
                    VISIT NOW →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HERO */}
      <section className="relative py-28 bg-gradient-to-br from-gray-950 via-black to-gray-900 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
          <div className="inline-flex items-center gap-3 bg-emerald-500/10 border border-emerald-500/30 px-8 py-3 rounded-3xl text-emerald-400 font-medium mb-8 shadow-[0_0_30px_rgb(16,185,129,0.3)]">
            <div className="w-3 h-3 bg-emerald-400 rounded-full animate-pulse" /> LIVE GLOBAL TRAFFIC
          </div>

          <h1 className="text-6xl md:text-7xl lg:text-8xl font-black tracking-[-3px] leading-none mb-8 bg-clip-text text-transparent bg-gradient-to-r from-white via-emerald-200 to-teal-300">
            BOOST YOUR BANNER<br />VISIBILITY FOR <span className="text-emerald-400">FREE</span>
          </h1>

          <p className="text-2xl text-gray-400 max-w-3xl mx-auto mb-12">
            Every unique visit = +1 point. Climb the global leaderboard and get real traffic.
          </p>

          <div className="flex flex-wrap justify-center gap-6 text-3xl font-bold mb-14">
            <div className="bg-gray-900/70 backdrop-blur px-8 py-4 rounded-2xl border border-emerald-500/20">75,000 visits this month</div>
            <div className="bg-gray-900/70 backdrop-blur px-8 py-4 rounded-2xl border border-emerald-500/20">2,500 visits today</div>
          </div>

          <div className="flex flex-col sm:flex-row gap-5 justify-center">
            <a href="/submit" className="px-14 py-6 bg-gradient-to-r from-emerald-500 to-teal-500 text-xl font-bold rounded-3xl hover:scale-105 transition-all shadow-[0_0_40px_rgb(16,185,129)]">
              SUBMIT MY BANNER NOW
            </a>
            <a href="/leaderboard" className="px-14 py-6 border-2 border-gray-700 hover:border-emerald-400 rounded-3xl text-xl font-bold transition-all">
              SEE LIVE LEADERBOARD
            </a>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS - TIMELINE */}
      <section className="py-24 bg-gray-900 relative">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-5xl font-black text-center mb-20 tracking-tight">3 STEPS. ZERO COST. REAL TRAFFIC.</h2>

          <div className="relative max-w-4xl mx-auto">
            <div className="hidden md:block absolute top-12 left-1/2 w-0.5 h-[calc(100%-6rem)] bg-gradient-to-b from-emerald-500/30 to-transparent" />

            <div className="grid md:grid-cols-3 gap-12 relative">
              {[
                { num: "01", title: "Submit Your Banner", desc: "Direct link or upload – takes 30 seconds" },
                { num: "02", title: "Share Everywhere", desc: "Autosurf, Telegram, Discord, forums, social media..." },
                { num: "03", title: "Earn & Climb", desc: "Every unique visit = +1 point. Climb the ranks!" }
              ].map((step, i) => (
                <div key={i} className="group relative bg-gray-950 border border-gray-800 rounded-3xl p-10 hover:border-emerald-500 transition-all hover:-translate-y-2">
                  <div className="text-8xl font-black text-emerald-500/10 group-hover:text-emerald-500/20 transition absolute top-6 right-6">{step.num}</div>
                  <div className="text-4xl font-bold mb-6 text-emerald-400">{step.title}</div>
                  <p className="text-gray-400 text-lg leading-relaxed">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ZEROADS BOTTOM */}
      <div className="flex justify-center py-12 bg-gray-900">
        <iframe 
          src="https://zerads.com/ad/ad.php?width=728&ref=10558" 
          width="728" height="90" scrolling="no" border="0" frameBorder="0"
        />
      </div>

      {/* FINAL CTA */}
      <div className="py-28 bg-gradient-to-r from-emerald-950 via-black to-teal-950 text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-6xl font-black tracking-tight mb-8">READY TO EXPLODE YOUR TRAFFIC?</h2>
          <a href="/submit" className="inline-block px-16 py-7 text-2xl font-bold bg-white text-black rounded-3xl hover:bg-emerald-400 hover:text-black transition-all scale-105 shadow-[0_0_60px_rgb(16,185,129)]">
            SUBMIT MY BANNER → LET’S GO
          </a>
        </div>
      </div>

      {/* FOOTER */}
      <footer className="bg-gray-950 border-t border-gray-800 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 text-sm text-gray-500">
            <div>© 2026 RankMyBanner • All Rights Reserved</div>
            <div className="flex gap-8">
              <a href="/" className="hover:text-gray-300">Home</a>
              <a href="/leaderboard" className="hover:text-gray-300">Leaderboard</a>
              <a href="/submit" className="hover:text-gray-300">Submit Your Banner</a>
              <a href="/claim" className="hover:text-gray-300">Claim Points</a>
              <a href="/how-to-increase" className="hover:text-gray-300">How to Increase</a>
            </div>
            
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;